import { render, staticRenderFns } from "./CompanyAddModule.vue?vue&type=template&id=839d427c&scoped=true&"
import script from "./CompanyAddModule.vue?vue&type=script&lang=js&"
export * from "./CompanyAddModule.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAddModule.vue?vue&type=style&index=0&id=839d427c&prod&scoped=true&lang=scss&"
import style1 from "./CompanyAddModule.vue?vue&type=style&index=1&id=839d427c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839d427c",
  null
  
)

export default component.exports